/**
 * Base class for share modal. Use prototypical inheritance to extend or overwrite functions
 *
 * Config file should include the following properties:
 * @btnShare <selector> - Selector of the share button that should open the modal
 * @parentEl <selector> - Parent element/container that encapsulates share button(s)
 * @el <selector> - The parent modal element (usually an id)
 */

function ModalShare(config) {
  this.config = config
  config && this.init()
}

// Initializes variables and bindings
ModalShare.prototype.init = function () {
  // Cache selectors
  this.$container = $(this.config.el)
  this.$shareBtn = $(this.config.btnShare)
  this.$shareEmailMsg = this.$container.find(".j-share-email-msg")
  this.$addMsgButton = this.$container.find(".j-add-msg")
  this.$emailSentButton = this.$container.find(".j-email-sent")
  this.$shareEmailSend = this.$container.find("#share-email-send")
  this.$shareEmailForm = this.$container.find(".j-share-email-form")
  this.$linkURLInput = this.$container.find(".j-share-link-url")
  this.$close = this.$container.find(".j-modal-close")
  this.$contentWrapper = this.$container.find(".modal-content-wrapper")

  // GA tracking
  this.gaTrackCategory = this.$container.data("ga-track-category")
  this.gaTrackAction = this.$container.data("ga-track-action")

  // Set up share hash
  this.createShareHash()

  // Load username in email form if signed-in
  if (
    slideshare_object &&
    slideshare_object.user &&
    slideshare_object.user.loggedin === true &&
    slideshare_object.user.login !== null
  ) {
    this.$container.find(".j-share-email-name").val(slideshare_object.user.login)
  }

  // Setup callbacks and bindings
  this.bindModalToShareButtons()
  this.bindModalEvents()
  this.bindCustomModalEvents()
  this.adjustShareModalTop()
}

ModalShare.prototype.get_viral_share_url = function (type) {
  const $elem = $("li." + type + " a")
  let queryParam = this.data.ssLink
  if ($elem.length > 0) {
    queryParam = $.param($elem.data())
    !queryParam && (queryParam = this.data.ssLink)
  }
  return this.SHARE_HASH[type] + queryParam
}

ModalShare.prototype.get_viral_share_urls = function () {
  return {
    facebook: this.get_viral_share_url("facebook"),
    linkedin: this.get_viral_share_url("linkedin"),
    twitter: this.get_viral_share_url("twitter"),
    wordpress: this.get_viral_share_url("wordpress"),
    pinterest: this.get_viral_share_url("pinterest"),
  }
}

/**
 * Opens a popup to share a slideshow on a particular social network.
 * Implemented in subclasses.
 *
 * @type <String> social network site name
 */
ModalShare.prototype.sharePopup = function (type) {
  // Default width and height of popup
  let width = 626
  let height = 436

  let shareURL = this.data.social[type]
  if (shareURL === undefined) {
    return
  }

  // Following a viral share, we save it to the viral share database. For
  // networks other than facebook, we do not track *completed* shares, and
  // so for them we need to call saveShare to save the viral share in the
  // viral share DB as soon as we get the initial click. For facebook, we
  // insert a row into the viral share db on successful completion of the
  // share, so we do not do it here.
  if (type === "facebook") {
    // Facebook has a success callback
    if (window.FB) {
      this.postToFacebook()
      return
    }
  } else if (type === "linkedin") {
    if (window.IN && window.IN.UI) {
      window.IN.UI.Share().params({ url: this.data.ssLink }).place()
      this.saveShare(type)
      return
    }
  }

  window.open(shareURL, "shareDialog", "width=" + width + ",height=" + height)
  this.saveShare(type)
}

// Reinitialize the modal to default views
ModalShare.prototype.show = function () {
  this.reset()
  this.$container.show()
  this.shareGATracking("modalOpen")
}

// Close the modal.
// Implemented in subclasses
ModalShare.prototype.close = function () {
  this.reset()
  this.$container.hide()
}

// Reinitialize the modal to default views.
ModalShare.prototype.reset = function () {
  this.$container.find(".j-embed-use-ssl-cbox").prop("checked", false)

  $(".j-modal-popup").scrollTop(0)

  // Reset email form
  this.clearEmailFields()
  this.$shareEmailForm.show()
  this.$emailSentButton.hide()

  // Collapse any expanded divs
  this.collapseAllSections()
}

/**
 * Updates the embed iframe code via regexes
 */
ModalShare.prototype.updateEmbed = function () {
  let $embedLink = this.$container.find(".j-share-embed-link")
  let newLink = $embedLink.val()
  let selectedSizeBlock = this.$container.find(".j-embed-size-picker").val()
  let width =
    this.$container.find(".j-embed-size-picker :selected").data("width") ||
    this.config.embed_sizes.presets[selectedSizeBlock].size.width
  let height =
    this.$container.find(".j-embed-size-picker :selected").data("height") ||
    this.config.embed_sizes.presets[selectedSizeBlock].size.height
  let url = newLink.match(/src="([^"]+)"/)[1].split("?")[0] // TODO: check for undefined values
  let startSlide = this.$container.find(".j-embed-start-picker").prop("selectedIndex") + 1 || 1
  url += startSlide > 1 ? "?startSlide=" + startSlide : ""
  newLink = newLink.replace(/src="[^"]+"/, 'src="' + url + '"')
  newLink = newLink.replace("http:", "")
  newLink = newLink.replace("https:", "")
  newLink = newLink.replace(/height="\d+"/, 'height="' + height + '"')
  newLink = newLink.replace(/width="\d+"/, 'width="' + width + '"')
  $embedLink.val(newLink)
}

ModalShare.prototype.clearEmailErrorAlerts = function () {
  $(".error").removeClass("error")
}

ModalShare.prototype.clearEmailFields = function () {
  this.$container.find(".j-email-clear").val("")
  this.$shareEmailSend.prop("disabled", false)
  this.clearEmailErrorAlerts()
}

/**
 * Sends share email via ajax call
 */
ModalShare.prototype.sendShareEmail = function (e) {
  this.shareGATracking("share_email", "send")
  let that = this
  let recipients = this.$container.find(".j-share-email-to").val()
  let name = this.$container.find(".j-share-email-name").val()
  let msg = this.$shareEmailMsg.val()
  let isSending = false

  // Replace send with sending
  that.$shareEmailSend.val("")
  that.$shareEmailSend.addClass("sending")
  that.$shareEmailSend.prop("disabled", true)
  that.clearEmailErrorAlerts()

  // Make sure email is not being sent
  if (!isSending) {
    isSending = true

    $.post("/w/list/email_share", {
      data: {
        id: this.data.ssId,
        name: name,
        recipients: recipients,
        msg: msg,
      },
      dataType: "json",
    })
      .done(function (data) {
        if (data.respCode === 0) {
          // Clear all current values
          that.clearEmailFields()

          // Hide email form
          that.$shareEmailForm.slideUp(400)
          that.collapseAllSections()

          // Display email sent div
          that.$container.find("#email-sent").slideDown(400)
          setTimeout(function () {
            that.$container.find("#email-sent").slideUp(400)
            that.$shareEmailForm.slideDown(400)
          }, 2000)
          that.$contentWrapper.removeClass("email-expanded")
        } else {
          let $emailFlash = that.$container.find(".j-email-flash")
          $emailFlash.text(data.resp).show()
          switch (data.respCode) {
            case 1: // Error in 'to' field
              that.$container.find(".j-share-email-to").addClass("error")
              break
            case 2: // Error in 'from' field
              that.$container.find(".j-share-email-name").addClass("error")
              break
            default: // Other error -- no field highlighting
              break
          }
          setTimeout(function () {
            $emailFlash.fadeOut(400)
          }, 5000)
        }

        isSending = false
        that.$shareEmailSend.val("Send")
        that.$shareEmailSend.removeClass("sending")
        that.$shareEmailSend.prop("disabled", false)
      })
      .fail(function (xhr, status, error) {
        isSending = false
        that.$shareEmailSend.val("Send")
        that.$shareEmailSend.removeClass("sending")
        that.$shareEmailSend.prop("disabled", false)
      })
  }
}

/**
 * Google Analytics helper function
 */
ModalShare.prototype.shareGATracking = function (action, value) {
  let _gaq = window._gaq || []
  action = this.gaTrackAction ? this.gaTrackAction + "_" + action : action
  _gaq.push(["_trackEvent", this.gaTrackCategory, action, value])
}

ModalShare.prototype.renderSlideStartOptions = function () {
  let html = ""
  for (let i = 0; i < this.data.totalSlides; i++) {
    let fullSlides = "slide " + (i + 1)
    html += "<option "
    if (i === 0) {
      html += ' selected="selected"'
    }
    html += ">" + fullSlides + "</option>"
  }

  let $startPicker = this.$container.find(".j-embed-start-picker, .j-share-start-picker")
  $startPicker.empty()
  $startPicker.append(html)
  this.updateStartSlide()
}

/**
 * Sets up embed code options
 */
ModalShare.prototype.renderDefaultEmbedOptions = function () {
  // [width, height] of presentation and document sizes
  let slideshowDisplays = {
    0: {
      small: [344, 292],
      medium: [429, 357],
      large: [514, 422],
      default: [599, 487],
    },
    1: {
      small: [386, 410],
      medium: [481, 512],
      large: [576, 614],
      default: [672, 716],
    },
    3: {
      small: [340, 191],
      medium: [425, 239],
      large: [510, 287],
      default: [595, 335],
    },
  }

  // Render embed window size options picklist
  let sizes
  if (this.data.ssType === 3) {
    sizes = slideshowDisplays[3]
  } else {
    sizes = slideshowDisplays[this.data.ssType % 2]
  }

  let html = ""
  for (let option in sizes) {
    let fullSize = sizes[option][0] + " x " + sizes[option][1]
    html +=
      '<option value="' + option + '" data-width="' + sizes[option][0] + '" data-height="' + sizes[option][1] + '"'
    if (option === "default") {
      html += " selected"
    }
    html += ">" + fullSize + "</option>"
  }
  let $embedPicker = this.$container.find(".j-embed-size-picker")
  $embedPicker.empty()
  $embedPicker.append(html)

  // Set start picker to default value of 1
  this.$container.find(".j-embed-start-picker").prop("selecteIndex", 1)

  // Render Wordpress embed code
  this.$container.find(".j-share-embed-wp").val(this.data.social.wordpress)

  // Render embed code
  this.$container.find(".j-share-embed-link").text(this.data.embedCode)
}

ModalShare.prototype.toggleAddMessageHeight = function (expand) {
  this.$shareEmailMsg.toggleClass("msg-expanded", expand)
}

ModalShare.prototype.collapseAllSections = function () {
  $(".j-share-expand").slideUp()
  $("#share-embed-link").scrollTop(0)
  $(".j-triggered").removeClass("j-triggered")
  this.toggleAddMessageHeight(false)
}

ModalShare.prototype.triggerExpand = function (trigger) {
  this.collapseAllSections()
  $(trigger).addClass("j-triggered")
  $(trigger).siblings(".j-share-expand").slideDown(400, this.adjustShareModalTop.bind(this))

  this.$contentWrapper.removeClass("email-expanded embed-expanded")
  if ($(trigger).hasClass("j-share-email-to")) {
    this.$contentWrapper.addClass("email-expanded")
  } else if ($(trigger).hasClass("j-share-embed-link")) {
    this.$contentWrapper.addClass("embed-expanded")
  }
}

// Given an existing share URL with or without a slide param, returns
// a url for the preso denoted by the original url, starting at slide
// slide_no.
ModalShare.prototype.getNewSlideURL = function (old_url, slide_no) {
  let parser = document.createElement("a")
  parser.href = old_url
  let arr = parser.pathname.split("/")
  if (!arr[0]) {
    // Shift off leading slash (in Chrome and FF -- IE has no leading slash)
    arr.shift()
  }
  let len = arr.length
  let last = arr[len - 1]
  while (!last && len > 0) {
    // Pop off trailing slashes
    arr.pop()
    len--
    last = arr[len - 1]
  }
  // Remove the last element if it is a number, checking that it is at least
  // the 3rd element, so as not to overwrite stripped-titles that begin with
  // numbers ('arr' => ['<user.login>', '<ss.stripped_title>', '<page>'])
  if (parseInt(last, 10) && len > 2) {
    arr.pop()
  }
  // Push new slide number onto end, unless it's the default (1)
  slide_no > 1 && arr.push(slide_no)
  parser.pathname = arr.join("/")
  return parser.href
}

ModalShare.prototype.getSlideImageURL = function (slide_no) {
  return $('#svPlayerId .slide[data-index="' + slide_no + '"] .slide_image').data("full")
}

/**
 * Bind all default callbacks/actions for the modal that are common between
 * subclasses
 */
ModalShare.prototype.bindModalEvents = function () {
  let that = this

  // Close Share Modal
  this.$close.bind("click", function () {
    that.close()
  })

  // Change start slide
  this.$container.find(".j-share-start-picker").change(function (e) {
    that.updateStartSlide()
    that.shareGATracking("share_social", $(this).data("ga"))
  })

  // Send email callback
  this.$shareEmailForm.submit(function (e) {
    e.preventDefault()
    e.stopPropagation()
    that.sendShareEmail()
  })

  this.$shareEmailMsg.click(function () {
    that.toggleAddMessageHeight(true)
  })

  this.$container.find(".j-share-email-to, .j-share-email-name").click(function (e) {
    that.toggleAddMessageHeight(false)
  })

  this.$container.find(".j-share-social-list li").click(function (evt) {
    that.sharePopup($(this).data("network"))
    evt.preventDefault()
  })

  // Update embed link on dropdown updates
  this.$container.find(".j-update-embed").change(function () {
    that.updateEmbed()
  })

  // Select text on share text fields on click
  this.$container.find(".j-share-embed-link, .j-share-embed-wp, .j-last-screen-ssurl").bind("click", function () {
    this.select()
  })

  this.$container.find(".j-share-link-url").click(function () {
    this.select()
    that.shareGATracking("share_social", $(this).data("ga"))
  })

  // Google Analytics click tracking
  this.$container
    .find(".j-share-email-form input, .j-share-email-form textarea, .j-add-msg, .j-send-another-email")
    .click(function (e) {
      if ($(this).data("ga") !== "send") {
        that.shareGATracking("share_email", $(this).data("ga"))
      }
    })

  this.$container
    .find(".j-embed-use-ssl-cbox, .j-embed-related-cbox, .j-embed-size-picker, .j-embed-start-picker")
    .click(function () {
      that.shareGATracking("share_embed", $(this).data("ga"))
    })

  this.$container.find(".j-share-expand-trigger").focus(function () {
    if ($(this).siblings(".j-share-expand:visible").length > 0) {
      return
    }
    that.triggerExpand(this)
  })

  $(window).resize(function () {
    that.adjustShareModalTop()
  })

  // Bind escape key to close modal
  $(document).keydown(function (e) {
    if (e.which === 27) {
      e.preventDefault()
      that.close()
    }
  })

  // Make 'close' button sticky
  $(".j-modal-popup").on("scroll", function (e) {
    that.$close.css("top", 8 + $(this).scrollTop() + "px")
  })
}

/**
 * To be overwritten by subclass-specific bindings
 */
ModalShare.prototype.bindCustomModalEvents = function () {}

ModalShare.prototype.createShareHash = function () {
  //TODO: Pull this info in from somewhere else
  this.SHARE_HASH = {
    facebook: "https://www.facebook.com/sharer/sharer.php?",
    linkedin: "https://www.linkedin.com/cws/share?trk=SLIDESHARE&",
    twitter: "https://twitter.com/share?",
    wordpress: "",
    pinterest: "https://pinterest.com/pin/create/button/?",
  }
}

/**
 * Return the slideshow id
 *
 * @$node <jQuery node> - (Optional) node of element to search for data attribute
 */
ModalShare.prototype.getSSId = function ($node) {
  return $node.length ? $node.data("slideshowid") : slideshare_object.modal_player.get_ss_id()
}

/**
 * Binds all the share thumbnail button(s) within the parent container.
 * Only used in ListPageModalShare, so only implemented there
 */
ModalShare.prototype.bindModalToShareButtons = function () {}

// Save the share in the viral database
ModalShare.prototype.saveShare = function (network) {
  let that = this
  $.get("/account/get_form_authenticity_token").done(function (resp) {
    $.post("/share/viralshare", {
      data: {
        id: that.data.ssId,
        network: network,
      },
      authenticity_token: resp.auth_token,
    })
  })
}

// Pops up a modal inviting the user to like SlideShare.net on Facebook
// Only implemented for Player currently
ModalShare.prototype.showLikeUsModal = function () {}

// Use Facebook JS API to post share to facebook
ModalShare.prototype.postToFacebook = function () {
  let that = this

  // Facebook JS API is loaded in bigboot layout
  if (!window.FB) {
    return
  }

  // Only save the share if successfully saved
  let successCallback = function (resp) {
    if (resp && resp.post_id) {
      that.saveShare("facebook")
    }
    // TODO: re-enable showLikeUsModal after rebuilding with HTML5 like button
    // instead of iframe (tricky with loading it into a modal, as we do), so
    // that we can track clicks.  Additonally, change implementation so that
    // modal only appears once per session, not following every like.
    //
    // that.showLikeUsModal();
  }

  window.FB.ui(
    {
      method: "feed",
      display: "popup",
      link: this.data.ssLink,
    },
    successCallback
  )
}

// Dummy functions to override in child classes
ModalShare.prototype.adjustShareModalTop = function () {}
ModalShare.prototype.updateStartSlide = function () {}

export default ModalShare
